import {connect} from 'react-redux';

import {InboxesPanelId} from '../../../../../libs/shared/core/src/store/panels/panelStateBase';
import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CollapsedItemStates, computeIsItemExpanded} from '../../../../helpers/expansionTogglingHelpers';
import {CollapsedItemKeyPrefixesEnum} from '../../../../models/api/localPreferencesModel';
import {VisualWorkspaceLens} from '../../../../models/api/visualWorkspaceModel';
import {
  dismissCreateLensDialog,
  showCreateLensDialog,
} from '../../../../store/panels/inboxes/inboxesPanelActions';
import {makeGetIsCreatingLens} from '../../../../store/panels/inboxes/inboxesPanelSelectors';
import {ToggleExpandItemHandler} from './context/types';
import {LensesWorkspaceEditor} from './lensesWorkspaceEditor';

/*
 * Constants.
 */

const lensesWorkspaceExpandedKey = `${CollapsedItemKeyPrefixesEnum.WORKSPACE}lenses`;
const defaultIsLensesWorkspaceExpanded = true;

/*
 * Props.
 */

interface LensesWorkspaceEditorContainerProps {
  /** Hash map of workspace item expansion toggle states. */
  collapsedItems: CollapsedItemStates;
  /** Handler for toggling the expanded/collapsed state of section items. */
  onToggleExpandSection: ToggleExpandItemHandler;
  visualWorkspaceLenses: ReadonlyArray<VisualWorkspaceLens>;
  panelId: InboxesPanelId;
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<LensesWorkspaceEditorContainerProps>()(() => {
  const getIsCreateDialogOpen = makeGetIsCreatingLens();
  return {
    isCreateDialogOpen: getIsCreateDialogOpen,
  };
});

export const LensesWorkspaceEditorContainer = connect(
  mapStateToProps,
  {
    showCreateLensDialog,
    dismissCreateLensDialog,
  },
  (stateProps, dispatchProps, ownProps: LensesWorkspaceEditorContainerProps) => {
    const {collapsedItems, onToggleExpandSection} = ownProps;

    const isExpanded = computeIsItemExpanded(
      collapsedItems,
      lensesWorkspaceExpandedKey,
      defaultIsLensesWorkspaceExpanded,
    );
    const onToggleExpand = () =>
      onToggleExpandSection({
        key: lensesWorkspaceExpandedKey,
        defaultExpandedState: defaultIsLensesWorkspaceExpanded,
      });

    const hideCreate = () => dispatchProps.dismissCreateLensDialog(ownProps.panelId);
    return {
      ...stateProps,
      ...ownProps,
      isExpanded,
      onToggleExpand,
      hideCreateLensDialog: hideCreate,
    };
  },
)(LensesWorkspaceEditor);
